export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE
};

export const isAuth0Enabled = Boolean(auth0Config.domain && auth0Config.clientId && auth0Config.audience);
